import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { BackButtonDeprecatedComponent } from "@hermes/aphrodite/back-button-deprecated";
import { BreadcrumbComponent } from "@hermes/aphrodite/breadcrumb";
import { CurrencyModule } from "@hermes/aphrodite/price";
import {
    svgDiagonal,
    svgExclamation,
    svgLivechat,
    SvgRegistryService,
    svgStore,
} from "@hermes/aphrodite/svg";
import { ZoomCursorDirective } from "@hermes/aphrodite/zoom-cursor";
import { LivechatDirectiveModule } from "@hermes/fragments/livechat-directive";
import { ModalModule } from "@hermes/fragments/modal";
import { ProductDeliveryDetailsModule } from "@hermes/fragments/product-delivery-details";

import { BackToGridService } from "@hermes/fragments/product-utils";
import { VtoModalServiceModule } from "@hermes/fragments/vto-button";
import { ZoomModule } from "@hermes/fragments/zoom";
import { BasketStateModule } from "@hermes/states/basket";
import { ProductPageStateModule } from "@hermes/states/product-page";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

import { CommonProductPageModule } from "./common/common-product-page.module";
import { ProductPageComponent } from "./components/product-page/product-page.component";
import { ProductPageRoutingModule } from "./product-page-routing.module";

@NgModule({
    imports: [
        // core import
        CommonModule,
        BackButtonDeprecatedComponent,
        // products pages modules
        CommonProductPageModule,
        ProductPageRoutingModule,
        LivechatDirectiveModule,
        // features modules
        BasketStateModule,
        CurrencyModule,
        ModalModule,
        BreadcrumbComponent,
        ZoomModule,
        ProductPageStateModule,
        ZoomCursorDirective,
        ProductDeliveryDetailsModule,
        VtoModalServiceModule,
        SrOnlyNoSnippetDirective,
    ],
    declarations: [ProductPageComponent],
    providers: [BackToGridService],
})
export class ProductPageModule {
    constructor(svgRegistryService: SvgRegistryService) {
        svgRegistryService.registerSvgs([
            svgExclamation,
            svgDiagonal,
            svgLivechat,
            svgStore,
        ]);
    }
}
